module.exports = __webpack_public_path__ + "static/media/PROP.29e90fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/PROP.jpg
// module id = 1371
// module chunks = 1